import { render, staticRenderFns } from "./LocationAddEditModal.vue?vue&type=template&id=5b5d0c90"
import script from "./LocationAddEditModal.vue?vue&type=script&lang=js"
export * from "./LocationAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports